var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('SSelect', {
    class: _vm.$style.FilterSelect,
    attrs: {
      "multiple": _vm.multiple,
      "label": _vm.label,
      "disabled": _vm.disabled,
      "size": "small",
      "theme": "secondary",
      "z-index": 10
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, _vm._l(_vm.computedItems, function (item) {
    return _c('SOption', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    }, [_vm._v("\n    " + _vm._s(item.label) + "\n  ")]);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };